import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AiNoMatchNotice = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  margin: '5px 0 10px',
  color: 'var(--dk-danger, #F54F61)',
  '& svg': { width: 16, height: 16, flexShrink: 0 },
});
